import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { altTextSourceDataAtom, altTextTreeAtom, byUrlDataAtom } from './atoms'
import { useCallback } from 'react'
import { ILeaf, INode } from 'shared/types/tree'
import { doLeafUpdate, doNodeUpdate, doUpdates } from './utility'

export function useUpdateAll() {
  const { resetTree } = useAtomValue(altTextTreeAtom)
  const allUrlData = useAtomValue(byUrlDataAtom)
  const sourceData = useAtomValue(altTextSourceDataAtom)
  return useCallback(
    async (toUpdateUrls: string[]) => {
      await doUpdates(toUpdateUrls, allUrlData, sourceData)
      return resetTree?.()
    },
    [allUrlData, resetTree, sourceData],
  )
}

export function useLeafUpdate() {
  const { resetTree } = useAtomValue(altTextTreeAtom)
  const allUrlData = useAtomValue(byUrlDataAtom)
  const sourceData = useAtomValue(altTextSourceDataAtom)

  return useCallback(
    async (leaf: ILeaf, url: string) => {
      await doLeafUpdate(url, leaf, allUrlData, sourceData)
      resetTree?.()
    },
    [resetTree, allUrlData, sourceData],
  )
}

export function useNodeUpdate() {
  const { resetTree } = useAtomValue(altTextTreeAtom)
  const allUrlData = useAtomValue(byUrlDataAtom)
  const sourceData = useAtomValue(altTextSourceDataAtom)

  return useCallback(
    async (node: INode, url: string) => {
      await doNodeUpdate(url, node, allUrlData, sourceData)
      resetTree?.()
    },
    [resetTree, allUrlData, sourceData],
  )
}
